export default __webpack_public_path__ + "static/media/matthew.90ae048f.png";